export default "__VITE_ASSET__BCV4EtdN__"